<mat-card class="information-rackxtender-card">
  <mat-card-header>
    <div mat-card-avatar class="modbus-header-image">
      <mat-icon aria-hidden="false" aria-label="home icon">memory</mat-icon>
    </div>
    <mat-card-title>RackXTender information</mat-card-title>
  </mat-card-header>
  <mat-card-content>

    <div *ngIf="information.xlrConfig_code == 115; else elseBlockPresent">
      <!--       RackXTender has  been initialized by config and is not needed -->
      RackXTender :
      <ul>
        <li>is initialized.</li>
        <li>Fieldstations configured:
          {{ information.xlrConfig_nrrack }} </li>
      </ul>

      RackXTender Fieldstations:
      <ul>
        <div *ngIf="information.xlrStatus_code == 254; else elseBlockDetected">
          <!--                 Field stations are present-->

          <div *ngIf="information.xlrConfig_nrrack != information.xlrStatus_nrrack; ">
            Warning: Configuration and detected are different!
          </div>

          <li>Stations configured:  {{ information.xlrConfig_nrrack }} </li>
          <li>Stations found:  {{ information.xlrStatus_nrrack }} </li>

          <div *ngIf="information.xlrStatus_status != 16; else elseBlockRing">
            <li>Communication ring: OPEN</li>
          </div>
          <ng-template #elseBlockRing>
            <li>Communication ring: CLOSED</li>
          </ng-template>
        </div>
        <ng-template #elseBlockDetected>
          <li>Not detected.</li>
        </ng-template>
      </ul>
    </div>
    <ng-template #elseBlockPresent>
      <!--       RackXTender has NOT been initialized by config and is not needed -->
      RackXTender :
      <ul>
        <li>is NOT initialized.</li>
      </ul>
    </ng-template>
  </mat-card-content>
</mat-card>


